import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import FlightImage from "../../assets/static/support.png";
import businessLoansImage from "../../assets/static/business/account_deposit.png"; // Update with your image path
import { Container, Row, Col, Button } from "react-bootstrap";

function BusinessDepositAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Business Loans? We’ve got you covered."
        description="Kontriman offers various ways to support your Business Loans – through our help center, chat support, and email. Get the assistance you need, anytime and anywhere."
        imageUrl={FlightImage}
      />
      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Image column */}
              <Col md={6} className="order-1 order-md-1">
                <img
                  src={businessLoansImage}
                  alt="Business Credit Account"
                  className="img-fluid"
                />
              </Col>

              {/* Text column */}
              <Col
                md={6}
                className="d-flex align-items-center order-2 order-md-2"
              >
                <div>
                  <h1 className="custom_heading">Business Credit Account</h1>
                  <p>
                    Our Business Credit Account empowers your enterprise with
                    flexible financing options to manage operational expenses,
                    take advantage of market opportunities, or improve cash
                    flow.
                  </p>

                  <h5 className="mt-4">Key Features</h5>
                  <ul>
                    <li>
                      Competitive interest rates and flexible repayment terms
                    </li>
                    <li>Tailored limits to suit your business needs</li>
                    <li>Access to working capital when needed</li>
                    <li>Dedicated relationship manager support</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Registered business with valid documentation</li>
                    <li>Good credit standing</li>
                    <li>Minimum operational history of 12 months</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">Apply Now</Button>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>

      <Footer></Footer>
    </div>
  );
}

export default BusinessDepositAccount;
